import React from 'react'
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
            There are a few ways to reach out to me, however the best way is by email @ <i className='footer-subscription-email'>dfrajerman@gmail.com</i>.
        </p>
        <p className='footer-sub-text'>
            I am based out of Howard County Maryland.
        </p>
        <p className='footer-sub-text'>
            I am proficient in English
        </p>
      </section>
      <section className='social-media'>
        <div className='social-media-wrap'>
            <div className='footer-logo'>
                <Link to='/' className='social-logo'>
                    DMF
                </Link>
            </div>
            <small className='website-rights'>DMF © 2023</small>
            <div className='social-icons'>
                <a href='https://www.facebook.com/dylan.frajerman/'
                className='social-icon-link facebook'
                target='_blank'
                rel="noreferrer"
                aria-label='Facebook'>
                    <i class="fab fa-facebook-f"></i>
                </a>
                <a href='https://www.instagram.com/dylan_frajerman/'
                className='social-icon-link instagram'
                target='_blank'
                rel="noreferrer"
                aria-label='Instagram'>
                    <i class="fab fa-instagram"></i>
                </a>
                <a href='https://www.youtube.com/@dylanfrajerman1257'
                className='social-icon-link youtube'
                target='_blank'
                rel="noreferrer"
                aria-label='Youtube'>
                    <i class='fab fa-youtube' />
                </a>
                <a href='https://www.linkedin.com/in/dylan-frajerman-14327621a/'
                className='social-icon-link linkedin'
                target='_blank'
                rel="noreferrer"
                aria-label='LinkedIn'>
                    <i class='fab fa-linkedin' />
                </a>
                <a href='https://github.com/dummyrock/'
                className='social-icon-link github'
                target='_blank'
                rel="noreferrer"
                aria-label='GitHub'>
                    <i class='fab fa-github' />
                </a>
            </div>
        </div>
      </section>
    </div>
  )
}

export default Footer 